import FirmApi from '../../services/FirmApi'

export const user = {
    namespaced: true,
    state: {
        id: 0,
        token: '',
        email: '',
        tel1: '',
        userFirms: null,
    },
    mutations: {
        setUser(state, payload) {
            state.id = payload.user_id
            state.token = payload.token
            state.email = payload.email
            state.tel1 = payload.tel1
        },
        setUserFirms(state, payload) {
            state.userFirms = payload
        },
    },
    actions: {
        /**
         * nastaví uživatelské údaje
         * @param commit
         * @param payload
         */
        setUser({ commit }, payload) {
            commit('setUser', payload)
        },
        /**
         * vrací uživatelské údaje z API
         * @param commit
         * @returns {Promise<any>}
         */
        getUser({ commit }) {
            return new Promise((resolve, reject) => {
                FirmApi.fetchUser()
                    .then(response => {
                        if (response.data.status == true) {
                            const {
                                user_id,
                                token,
                                email,
                                tel1,
                                firmy,
                            } = response.data.results
                            commit('setUserFirms', firmy)
                            commit('setUser', { user_id, token, email, tel1 })
                            commit(
                                'firm/setFormData',
                                {
                                    email,
                                    telefon: tel1,
                                    www: '',
                                    popis: '',
                                },
                                { root: true }
                            )
                            resolve(true)
                        } else {
                            resolve(false)
                        }
                    })
                    .catch(function(error) {
                        reject(error)
                    })
            })
        },
    },
}
